import { useTranslation } from "react-i18next";
import {
  InputAdornment,
  TextField,
  TextFieldProps,
  Typography,
} from "@material-ui/core";
import WithIconHelper from "components/WithIconHelper";
import { useStyles } from "../styles";
import { MxheroShareConfig } from "@dashboard-v3/api";

interface Props {
  isReadOnly: boolean;
  error: string;
  disabled: boolean;
  value: string;
  onChange: (update: Partial<MxheroShareConfig>) => void;
}

export default function SubdomainInput(props: Props) {
  const { t } = useTranslation("mxheroShares");
  const classes = useStyles();
  const { value, error, isReadOnly, disabled } = props;

  const onChange: TextFieldProps["onChange"] = e => {
    const { value } = e.target;
    props.onChange({ subdomain: value });
  };

  if (isReadOnly) {
    return (
      <div className={classes.inputContainer}>
        <div style={{ marginBottom: 10 }}>
          <Typography variant="subtitle2">
            {t("settings.inputTitle")}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {t("settings.inputSubtitleReadOnly")}
          </Typography>
        </div>
        <TextField
          label={t("settings.inputLabel")}
          className={classes.disabledInput}
          variant="outlined"
          disabled
          fullWidth
          value={value}
        />
      </div>
    );
  }

  return (
    <div className={classes.inputContainer}>
      <div style={{ marginBottom: 10 }}>
        <Typography variant="subtitle2">
          {t("settings.inputTitle")}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {t("settings.inputSubtitle")}
        </Typography>
      </div>
      <WithIconHelper
        position="after"
        buttonStyles={{ marginLeft: "10px" }}
        text={t("settings.inputHelper")}
      >
        <TextField
          variant="outlined"
          className={classes.enabledInput}
          fullWidth
          name="subdomain"
          label={t("settings.inputLabel")}
          placeholder={t("settings.inputPlaceholder")}
          error={Boolean(error)}
          helperText={error}
          disabled={disabled}
          value={value}
          onChange={onChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">https://</InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="start">
                {process.env.REACT_APP_MXHERO_SHARE_DOMAIN}
              </InputAdornment>
            ),
          }}
        />
      </WithIconHelper>
    </div>
  );
}
